import { jbColors } from 'theme/jbColors';

const MuiAppBar = {
  styleOverrides: {
    colorSecondary: {
      position: 'sticky',
      padding: '0px 32px 0px 32px',
      zIndex: 1,
      backgroundColor: jbColors.app.white,
    },
  },
};

export default MuiAppBar;
